import { makeVisibleData } from '../plugins/filters/filters.selectors'
import Settings from 'settings'

export const projects = {
  name: 'projects',
  request: {
    url: `${Settings.api}/projects?custom_per_page=100`,
    middleware: {
      // checkStore: (store) => store.projects.data.length, // check if data is already in the store
    }
  },
  state: {
    data: [], // items needs an empty array, so we override default 'data' here
  },
  filters: {
    filter: (item, test) => true,
    cat: (item, test) => item.categories.includes(test),
    // gender: (item, test) => item.gender.toLowerCase() === test.toLowerCase(),
    // search: (item, test) => `${item.first_name}${item.last_name}`.toLowerCase().includes(test.toLowerCase())
  },
  urlQuery: true, // e.g: /projects?gender=male
}

export const getVisibleData = makeVisibleData(projects.filters)



// WEBPACK FOOTER //
// ./src/redux/models/projects.js